import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Seo from './components/Seo';
import VisitorTracker from './components/VisitorTracker';
import Home from './pages/Home';
import HomeDraft from './pages/HomeDraft';
import About from './pages/About';
import Plans from './pages/Plans';
import PhoneService from './pages/PhoneService';
import CheckService from './pages/CheckService';
import Support from './pages/Support';
import Contact from './pages/Contact';
import Chat from './pages/Chat';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ServiceAcknowledgment from './pages/ServiceAcknowledgment';
import TowerStatus from './pages/TowerStatus';
import HowItWorks from './pages/HowItWorks';
import Gamers from './pages/Gamers';
import InternetKingman from './pages/InternetKingman';
import InternetGoldenValley from './pages/InternetGoldenValley';
import PhoneKingman from './pages/PhoneKingman';
import PhoneGoldenValley from './pages/PhoneGoldenValley';
import PayBill from './pages/PayBill';
import PaymentExtension from './pages/PaymentExtension';
import NotFound from './pages/NotFound';

function App() {
  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    // Disable text selection via keyboard shortcuts
    const handleKeyDown = (e: KeyboardEvent) => {
      // Disable Ctrl+C, Ctrl+A, Ctrl+U (view source)
      if (e.ctrlKey && (e.key === 'c' || e.key === 'a' || e.key === 'u')) {
        e.preventDefault();
        return false;
      }
      // Disable F12 (developer tools)
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="min-h-screen flex flex-col">
        <Seo />
        <VisitorTracker />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home-draft" element={<HomeDraft />} />
            <Route path="/about" element={<About />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/phone-service" element={<PhoneService />} />
            <Route path="/phone-kingman-az" element={<PhoneKingman />} />
            <Route path="/phone-golden-valley-az" element={<PhoneGoldenValley />} />
            <Route path="/check-service" element={<CheckService />} />
            <Route path="/support" element={<Support />} />
            <Route path="/pay-bill" element={<PayBill />} />
            <Route path="/payment-extension" element={<PaymentExtension />} />
            <Route path="/tower-status" element={<TowerStatus />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/service-acknowledgment" element={<ServiceAcknowledgment />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/gamers" element={<Gamers />} />
            <Route path="/internet-kingman-az" element={<InternetKingman />} />
            <Route path="/internet-golden-valley-az" element={<InternetGoldenValley />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

